import React from "react";
import svg167 from "../../../../assets/svg/svg167.svg";

function AirtimeHeader() {
  return (
    <div className="rounded-[0.75rem] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)] p-[0.75rem] ">
      <div className="flex items-center gap-[0.5rem]">
        <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-[#1E191B] flex items-center justify-center">
          <img src={svg167} alt="svg167" />
        </div>
        <span className="text-[#0F172A] font-[500] font-lexendS text-[0.875rem] leading-[1.5rem]">
          Airtime & Data Purchase
        </span>
      </div>
    </div>
  );
}

export default AirtimeHeader;
